export const isOverflowing = (element: HTMLElement) => element.scrollWidth > element.clientWidth;
